'use client'

import { useTranslation } from '../../hooks/useTranslation';

export default function AboutUs() {
  const { t } = useTranslation();

  const handleCallClick = () => {
        window.location.href = `/cars`;
    };
  return (
    <section className="relative min-h-screen w-full overflow-hidden" id="about-us-home">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/images/about.jpg')`
        }}
      />

      {/* Mobile Background Overlay for better readability */}
      <div className="absolute inset-0 bg-black/40 md:bg-black/20 lg:bg-transparent"></div>

      {/* Content Container */}
      <div className="relative z-10 min-h-screen flex items-center">
        {/* Content Wrapper */}
        <div className="container ml-2 lg:ml-[120px] xl:ml-[120px]">
          {/* Mobile: Centered content */}
          <div className="block md:hidden text-center">
            <div className="bg-[#11111196] backdrop-blur-[2px] shadow-[0px_4px_4px_0px_#00000040] rotate-0 p-8 lg:p-10 xl:p-12 max-w-lg xl:max-w-xl rounded-[15px]">
              <h4 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-6 lg:mb-8 xl:mb-10 text-left">{t('about.title')}</h4>

              <p className="text-gray-300 mb-8 lg:mb-10 xl:mb-12 leading-relaxed text-base lg:text-lg xl:text-xl text-left">{t('about.desc')}</p>

              <div className="flex">
                <button onClick={handleCallClick} className="ml-auto bg-[#006FFF] hover:bg-blue-700 text-white px-8 lg:px-10 xl:px-12 py-3 lg:py-4 rounded-[25px] font-semibold transition-all duration-300 hover:shadow-lg hover:scale-105">
                  {t('explore')}
                </button>
              </div>
            </div>
          </div>

          {/* Tablet: Left-aligned but more centered */}
          <div className="hidden md:block lg:hidden">
            <div className="bg-[#11111196] backdrop-blur-[2px] shadow-[0px_4px_4px_0px_#00000040] rotate-0 p-8 lg:p-10 xl:p-12 w-full sm:w-[300px] md:w-[720px] lg:w-[844px] rounded-[15px]">
              <h4 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-6 lg:mb-8 xl:mb-10 text-left">{t('about.title')}</h4>

              <p className="text-gray-300 mb-8 lg:mb-10 xl:mb-12 leading-relaxed text-base lg:text-lg xl:text-xl text-left">
                {t('about.desc')}
              </p>

              <div className="flex">
                <button onClick={handleCallClick} className="ml-auto bg-[#006FFF] hover:bg-blue-700 text-white px-8 lg:px-10 xl:px-12 py-3 lg:py-4 rounded-[25px] font-semibold transition-all duration-300 hover:shadow-lg hover:scale-105">
                  {t('explore')}
                </button>
              </div>
            </div>
          </div>

          {/* Desktop: Original left-positioned overlay */}
          <div className="hidden lg:block">
            <div className="bg-[#11111196] backdrop-blur-[2px] shadow-[0px_4px_4px_0px_#00000040] rotate-0 ml-8 p-8 lg:p-10 xl:p-12 w-full sm:w-[300px] md:w-[720px] lg:w-[844px] rounded-[15px]">
              <h4 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-6 lg:mb-8 xl:mb-10 text-left">{t('about.title')}</h4>

              <p className="text-gray-300 mb-8 lg:mb-10 xl:mb-12 leading-relaxed text-base lg:text-lg xl:text-xl text-left">
                {t('about.desc')}
              </p>

              <div className="flex">
                <button onClick={handleCallClick} className="ml-auto bg-[#006FFF] hover:bg-blue-700 text-white px-8 lg:px-10 xl:px-12 py-3 lg:py-4 rounded-[25px] font-semibold transition-all duration-300 hover:shadow-lg hover:scale-105">
                  {t('explore')}
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}